export interface IPaperSize {
  code: string;
  name: string;
  multiplesOfFourCode: string;
}
export const PaperSizes: IPaperSize[] = [
  {
    code: "A0",
    name: "A0 (841 x 1189 mm)",
    multiplesOfFourCode: "",
  },
  {
    code: "A1",
    name: "A1 (595 x 841 mm)",
    multiplesOfFourCode: "A0",
  },
  {
    code: "A2",
    name: "A2 (595 x 420 mm)",
    multiplesOfFourCode: "A1",
  },
  {
    code: "A3",
    name: "A3 (297 x 420 mm)",
    multiplesOfFourCode: "A2",
  },
  {
    code: "A4",
    name: "A4 (297 x 210 mm)",
    multiplesOfFourCode: "A3",
  },
  {
    code: "A5",
    name: "A5 (148 x 210 mm)",
    multiplesOfFourCode: "A4",
  },
];
